import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
    Input,
    Form,
    Button,
    Space,
    DatePicker,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import commonStyles from '../../../../Utils/Common.less'
import { SaveOutlined } from '@ant-design/icons'

import { useDispatch } from 'react-redux'
import {
    type ProspectPhoneCallProps,
    type ProspectClientFormDataInterface,
} from '../../../../Types/Client/ProspectClients/prospectClient'
import {
    GetInvidualProsPectDetails,
    SaveCommuniCationProspectClient,
} from '../../../../Services/ProspectClient'
import moment from 'moment'
import dayjs from 'dayjs'

const ProspectPhoneCall = (
    props: ProspectPhoneCallProps
): React.ReactElement => {
    const {
        prospectClientId,
        changePhoneCallModalStatus,
        phonecallModelClick,
        setPhoneCallModelClick,
    } = props
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [induvidualPhoneCallDetails, setInduvidualPhoneCallDetails] =
        useState<ProspectClientFormDataInterface | null>(null)
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [buttonloading, setButtonLoading] = useState(false)
    useEffect(() => {
        const fetchData = (): void => {
            void GetInvidualProsPectDetails(
                dispatch,
                prospectClientId,
                (details: ProspectClientFormDataInterface) => {
                    setInduvidualPhoneCallDetails(details)
                }
            )
        }
        fetchData()
        setPhoneCallModelClick(false)
    }, [phonecallModelClick, prospectClientId])

    useEffect(() => {
        if (
            induvidualPhoneCallDetails !== null &&
            typeof induvidualPhoneCallDetails === 'object'
        ) {
            const newFieldValues = {
                firstName: induvidualPhoneCallDetails?.firstName,
                mobileNumber: induvidualPhoneCallDetails?.mobileNumber,
            }

            form.setFieldsValue(newFieldValues)
        }
    }, [induvidualPhoneCallDetails, form])

    useEffect(() => {
        form.setFieldValue('historyDate', selectedDate)
    }, [prospectClientId, selectedDate])

    const onChange = (
        dateOfBirth: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
        }
    }

    const onSave = (): void => {
        void onSavePhone()
    }
    const onSavePhone = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            const formData = form.getFieldsValue()

            const dataToSave = {
                otherCommunicationHistoryId: 0,
                communicationModeId: 3,
                communicationTypeId: 3,
                businessTypeId: 0,
                referenceId: prospectClientId,
                contactNumber: formData.mobileNumber,
                description: formData.description,
                historyDate: moment(formData.historyDate).format(
                    'DD/MM/YYYY h:mm:ss A'
                ),
            }

            await SaveCommuniCationProspectClient(dispatch, dataToSave).then(
                (result) => {
                    if (result !== null && result !== undefined) {
                        form.setFieldsValue({
                            description: '',
                            historyDate: '',
                        })

                        changePhoneCallModalStatus()
                        setSelectedDate('')
                        setButtonLoading(false)
                    }
                }
            )
        } catch (error) {
            console.error('Error:', error)
        }
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                name="complex-form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
            >
                <Form.Item<ProspectClientFormDataInterface>
                    name="prospectClientId"
                    hidden={true}
                    initialValue={prospectClientId}
                >
                    <Input />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<ProspectClientFormDataInterface>
                            label="Name"
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your firstName!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<ProspectClientFormDataInterface>
                            label="Phone Number"
                            name="mobileNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Please enter a valid mobile number (10 to 15 digits).',
                                },
                                {
                                    required: true,
                                    message: 'Please input your mobile number!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Call Date"
                            name="historyDate"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Call Date!',
                                },
                            ]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    onChange={(date, dateString) => {
                                        onChange(date, dateString)
                                    }}
                                    value={
                                        selectedDate?.length > 0
                                            ? dayjs(selectedDate)
                                            : null
                                    }
                                    format="DD/MM/YYYY h:mm:ss A"
                                    showTime
                                    className={commonStyles.dateWidth}
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Comments"
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Comments',
                                },
                            ]}
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col offset={21} span={2}>
                        <Tooltip title="Save">
                            <Button
                                type="primary"
                                onClick={onSave}
                                size="middle"
                                loading={buttonloading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default ProspectPhoneCall
